// extracted by mini-css-extract-plugin
export default {"back-button":"CompareHeader_back-button__BC-MD"};